"use client";

import React, { useContext } from "react";
import { SpacingType, sectionVariants, ButtonStyleType } from "@/types";
import { SectionWrapper } from "../components/SectionWraper";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import parse from "html-react-parser";
import { PageContext } from '@/components/builder';

interface Hero17Props {
  darkMode?: boolean;
  spacing?: SpacingType;
  variant?: sectionVariants;
  contents?: {
    badge?: string;
    title?: string;
    content?: string;
    microCopy?: string;
    showLastUpdatedDate?: boolean;
    hasButton?: boolean;
    buttonText?: string;
    buttonLink?: string;
    buttonStyle?: ButtonStyleType;
    secondaryButton?: boolean;
    secondaryButtonText?: string;
    secondaryButtonLink?: string;
    secondaryButtonStyle?: ButtonStyleType;
  };
  attributes?: React.HTMLProps<HTMLElement>;
}

const Hero17 = ({
  darkMode = false,
  spacing,
  variant = 'A',
  contents,
  attributes,
}: Hero17Props) => {

  const { data } = useContext(PageContext);

  return (
    <SectionWrapper 
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="hero17"
      attributes={attributes}
      usedInPageNav={false}
      pageNavTitle="Hero 17"
    >     
      <div className="container"> 
        <div className="flex flex-col xl:flex-row gap-x-20">
          <div className="xl:w-[60%]">
            {contents?.badge && (
              <Badge variant="outline" bold className="mb-6">
                {contents?.badge}
              </Badge>
            )}
            {contents?.title && (
              <>
              <h1 className="mb-8">
                {parse(contents.title)}
              </h1>
              </>
            )}
            {contents?.content && (
              <div className="paragraph-lg mx-auto !font-normal">
                {parse(contents?.content)}
              </div>
            )}
            {contents?.showLastUpdatedDate && (
              <p className="paragraph-sm mt-3">
                Last updated: {(data as unknown as { updatedAt?: string })?.updatedAt ? new Date((data as unknown as { updatedAt?: string }).updatedAt!).toLocaleDateString('en-GB') : ''}
              </p>
            )}
            {contents?.hasButton && (
              <div className="mt-8 flex flex-col">
                <div className="flex flex-col gap-2 sm:flex-row">
                  <Button 
                    size="lg" 
                    variant={contents?.buttonStyle || "primary"}
                    className="w-full gap-2 sm:w-auto"
                    asChild
                  >
                    <a href={contents?.buttonLink}>
                      {contents?.buttonText}
                    </a>
                  </Button>
                  {contents?.secondaryButton && (
                    <Button
                      variant={contents?.secondaryButtonStyle || "outline"}
                      size="lg"
                      className="w-full gap-2 sm:w-auto"
                      asChild
                    >
                      <a href={contents?.secondaryButtonLink}>
                        {contents?.secondaryButtonText}
                      </a>
                    </Button>
                  )}
                </div>
                {contents?.microCopy && (
                  <p className="paragraph-sm text-muted-foreground mt-3 text-center md:text-left">
                    {contents?.microCopy}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Hero17 };     
